import { GameType } from "@/domains/games/types";

export const PROMOTION_ACTION = {
  registration: "registration",
  firstDeposit: "first_deposit",
  secondDeposit: "second_deposit",
};

export interface IPromoFieldFetch {
  country?: string | null;
  action?: string;
  ended?: boolean;
}

export type PromoType = {
  id: string;
  title: string;
  description?: string;
  image?: string;
  imageSmall?: string;
  country?: string | null;
  game?: GameType;
  wager: number;
  freespins?: number;
  daysExpire: number;
  minDeposit: number;
  maxBonus: number;
  bonus: number;
  bonusPercent: number;
  ended: boolean;
  startAt: Date;
  endAt: Date;
};

export type UserPromoType = {
  promotion: PromoType;
  totalBet: number;
  bonus: number;
  freespins?: number;
  deposit: boolean;
  active: boolean;
  ended: boolean;
  endAt: Date;
};

export interface IPromoProps {
  country?: string | null;
  isOpen: boolean;
  onClose: () => void;
  promoId: string | null;
  setPromoId: (id: string | null) => void;
}

export interface IPromo {
  id: string;
  title: string;
  description?: string;
  image?: string;
  imageSmall?: string;
  game?: GameType;
  wager: number;
  freespins?: number;
  daysExpire: number;
  minDeposit: number;
  maxBonus: number;
  bonus: number;
  bonusPercent: number;
  ended: boolean;
  startAt: Date;
  endAt: Date;
}

export interface IPromoCardProps {
  promo: IPromo;
  promoId?: string | null;
  onActivePromo: (value: string | null) => void;
  onMoreDetail: (value: IPromo | null) => void;
}

export type UserAcceptRequestType = {
  promoId?: string;
};

export type UserPromoAcceptType = {
  success: boolean;
};

export type UserChangeRequestType = {
  promoId?: string;
};
